var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"scroll-top"}},[(_vm.show)?_c('div',{staticClass:"scroll-top",on:{"click":function($event){return _vm.toTop()}}},[_c('i',{staticClass:"fas fa-arrow-up"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }